import { inject, Injectable } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { DynamicAssetLoaderService, DynamicLoaderInlineAssets } from '@rma/public/generic/util/dynamic-asset-loader';
import { Environment } from '@rma/public/generic/util/environment';
import { HotJarEventType, HotJarSurvey } from './domain/hotjar-event.model';
import { HotJarAttributes, HotJarWindow } from './domain/hotjar-window.model';

@Injectable({
  providedIn: 'root',
})
export class HotjarScriptService {
  private readonly window = inject<HotJarWindow>(WA_WINDOW);

  private readonly environment = inject(Environment);
  private readonly dynamicAssetLoader = inject(DynamicAssetLoaderService);

  public appendScript(): void {
    if (this.environment.tracking.hotjarId) {
      const i = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${this.environment.tracking.hotjarId},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=true;r.defer=true;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'//static.hotjar.com/c/hotjar-','.js?sv=');
      `;

      this.dynamicAssetLoader.appendInlineAsset(DynamicLoaderInlineAssets.Hotjar, i);
    }
  }

  public openSurvey(eventType: HotJarSurvey): void {
    this.trackHotjarEvent(eventType);
  }

  public trackEvent(eventType: HotJarEventType): void {
    this.trackHotjarEvent(eventType);
  }

  public identify(userId: string, attrs: HotJarAttributes = {}) {
    if (!this.window?.hj) {
      this.notLoadedError('Identify User');
      return;
    }
    this.window.hj('identify', userId, attrs);
  }

  private trackHotjarEvent(eventType: HotJarEventType | HotJarSurvey): void {
    if (!this.window?.hj) {
      this.notLoadedError(eventType);
      return;
    }
    this.window.hj('event', eventType);
  }

  private notLoadedError(eventType: string) {
    console.error(`${eventType} not sent as hotjar is not ready`);
  }
}
